import { createAsyncThunk } from '@reduxjs/toolkit';

import OneSpanSignApi from 'api/curo/OneSpanSignApi';
import { ApplicationProcessActionTypes } from 'enums/curo/ApplicationProcessActionTypes';

export const createCompleteSigningThunk = (api: OneSpanSignApi) =>
  createAsyncThunk(ApplicationProcessActionTypes.CompleteSigning, async () => {
    const response = await api.completeSigning();
    return response;
  });
